import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

const handleResponse = async (response, fallbackMessage) => {
  if (!response.ok) {
    let message = fallbackMessage;
    try {
      const data = await response.json();
      message = data.message || message;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }
  return response.json();
};

/**
 * Build query string from analytics filter object.
 * Arrays are joined as comma-separated values.
 */
export const buildAnalyticsQuery = (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.startDate) params.set("startDate", filters.startDate);
  if (filters.endDate) params.set("endDate", filters.endDate);
  if (filters.granularity) params.set("granularity", filters.granularity);

  const csvFields = [
    ["statuses", filters.statuses],
    ["confirmationCategories", filters.confirmationCategories],
    ["categoryIds", filters.categoryIds],
    ["brandIds", filters.brandIds],
    ["typeIds", filters.typeIds],
  ];

  csvFields.forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      params.set(key, value.join(","));
    }
  });

  if (filters.state) params.set("state", filters.state);
  if (filters.city) params.set("city", filters.city);
  if (filters.couponUsed === true || filters.couponUsed === false) {
    params.set("couponUsed", String(filters.couponUsed));
  }

  return params.toString();
};

/** GET /api/Analytics — full dashboard payload */
export const fetchAnalyticsDashboard = async (filters = {}) => {
  const qs = buildAnalyticsQuery(filters);
  const response = await fetch(`${API_BASE_URL}/Analytics${qs ? `?${qs}` : ""}`, {
    headers: authHeaders(),
  });
  return handleResponse(response, "فشل تحميل لوحة التحليلات");
};

/** GET /api/Analytics/filter-options */
export const fetchAnalyticsFilterOptions = async () => {
  const response = await fetch(`${API_BASE_URL}/Analytics/filter-options`, {
    headers: authHeaders(),
  });
  return handleResponse(response, "فشل تحميل خيارات التصفية");
};

/**
 * GET /api/Analytics/design-images?codes=A,B,C
 * Returns a map of design code → relative ImageUrl_1.
 */
export const fetchDesignImagesByCode = async (codes = []) => {
  const clean = codes.filter(Boolean);
  if (clean.length === 0) return {};
  const params = new URLSearchParams({ codes: clean.join(",") });
  const response = await fetch(
    `${API_BASE_URL}/Analytics/design-images?${params.toString()}`,
    { headers: authHeaders() }
  );
  return handleResponse(response, "فشل تحميل صور التصاميم");
};
